<ng-container *ngIf="params.linkEnabled && params.stateValue; else linkWithoutState">
  <a [routerLink]="params.inRouterLink" [state]="stateValue">{{params.value}}</a>
</ng-container>
<ng-template #linkWithoutState>
  <ng-container *ngIf="params.linkEnabled; else linkDisabled">
    <a [routerLink]="params.inRouterLink" [fragment]="params.fragment">{{params.value}}</a>
  </ng-container>
  <ng-template #linkDisabled>
    {{params.value}}
  </ng-template>
</ng-template>